import { useState, useEffect } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import MembersTable from "./components/MembersTable";
import CreateMemberModal from "./components/CreateMemberModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputBox from "../../components/input-box";
import { OrganizationType, Member } from "../../utils/types";
import { WithContext as ReactTags, Tag } from "react-tag-input";
import { useAlert } from "../../hooks/useAlert";
import ParentSearchBox from "./components/ParentSeachBox";
import StoreCollectionsTable from "./components/StoreCollectionsTable";
import DesignProducTemplate from "./components/DesignProductTemplateTable";
import { Toggle } from "../../components/toggle";
import affinity_clients from "./affinity-clients.json";
import {
  api,
  getOrganization,
  getOrganizationMembers,
} from "../../services/axios";
import { remove, union } from "lodash";

const KeyCodes = {
  enter: 13,
};

const delimiters = [KeyCodes.enter];

const initialData: OrganizationType = {
  website: "",
  affinity_organization_id: "0",
  motto_short: "",
  national: "",
  motto: "",
  motto_long: "",
  colloquial_phrase: "",
  colloquial_name: "",
  salesforce_id: "",
  full_name: "",
  menu_name: "",
  acronym_name: "",
  state: "",
  city: "",
  account_name: "",
  founding_year: "",
  default_name: "",
  colloquial_letters: "",
  licensing: [],
  category: "",
  id: "",
  tags: [],
  parents: [],
};

type TParams = { id: string };

export const Organization = (props: RouteComponentProps<TParams>) => {
  const history = useHistory();
  const alert = useAlert();

  const [parents, setParents] = useState<OrganizationType[]>([]);
  const [organization, setOrganization] = useState(initialData);
  const [tagInputValue, setTagInputValue] = useState("");
  const [members, setMembers] = useState<Member[]>([]);
  const [createMemberModalVisible, setCreateMemberModalVisible] =
    useState<boolean>(false);

  const handleIsNationalChange = async () => {
    await api.put(`organizations/${organization.salesforce_id}`, {
      national: organization.national === "True" ? "True" : "False",
    });

    fetchOrg();
  };

  const ID = props.match.params.id;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...organization,
      tags: organization.tags
        ? organization.tags.map(function (x) {
            return { id: x, text: x };
          })
        : [],
    },
    validationSchema: Yup.object({
      salesforce_id: Yup.string().min(2).max(30).required("Required"),
      full_name: Yup.string().min(1).max(50).required("Required"),
      default_name: Yup.string().min(1).max(50).required("Required"),
      category: Yup.string().min(1).max(50).required("Required"),
      menu_name: Yup.string().min(1).max(50).required("Required"),
    }),
    onSubmit: async (formData) => {
      console.log("formData", formData);
      try {
        let newTags = formData.tags?.map(function (x) {
          let tag = x as any;
          return tag.text;
        });
        await api.put(`organizations/${organization.salesforce_id}`, {
          ...formData,
          tags: newTags,
        });
        alert.showAlert(
          "Succesfully saved!",
          "Your organization data has been succesfully saved.",
          "Success"
        );
      } catch (e: any) {
        console.log("ERORR", e);
      }
    },
  });

  const fetchOrg = async () => {
    const result = (await getOrganization(ID)) as OrganizationType;
    const getMembers = (await getOrganizationMembers(ID)) as Member[];
    console.log("getMembers", getMembers);
    if (getMembers) {
      setMembers(getMembers);
    }
    console.log("result", result);
    setOrganization({
      ...organization,
      ...result,
    });
  };

  useEffect(() => {
    fetchOrg();
    formik.resetForm();
  }, [createMemberModalVisible]);

  useEffect(() => {
    const fetchParents = async () => {
      let p = await organization.parents?.map(async (parent) => {
        const foundParent = (await getOrganization(parent)) as OrganizationType;
        return foundParent;
      });
      let unwrapped: OrganizationType[] = await Promise.all(p);
      setParents([...parents, ...unwrapped]);
    };
    fetchParents();
  }, [organization]);

  function goBack() {
    history.push({
      pathname: `/organizations`,
    });
  }

  const handleDelete = (i: number) => {
    const next = formik
      .getFieldProps("tags")
      .value.filter((tag: Tag, index: number) => index !== i);
    formik.setFieldValue("tags", next);
  };

  const handleAddition = (tag: Tag) => {
    const next = [...formik.getFieldProps("tags").value, tag];
    formik.setFieldValue("tags", next);
  };

  const checkNational = (national: string) => {
    if (national === "True" || national === "TRUE") {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (formik.submitCount > 0 && !formik.isValid) {
      alert.showAlert(
        "Error saving!",
        "Some fields are not valid please check and try again.",
        "Error"
      );
    }
  }, [formik.submitCount, formik.isValid]);

  return (
    <div className="m-8 p-16">
      <div
        className="underline cursor-pointer text-deeppurple mb-10"
        onClick={() => goBack()}
      >
        Back to organizations
      </div>

      <h1 className="bold text-2xl">
        {organization.full_name ? organization.full_name : "no full name"} -{" "}
        {organization.salesforce_id
          ? organization.salesforce_id
          : "no salesforce id"}
        :{"    "}
        {organization.salesforce_id
          ? organization.account_name
          : parents
              ?.map((parent) => {
                return parent?.full_name;
              })
              .join("  ")}
      </h1>

      <div className="my-8  w-full border border-b  rounded">
        <h3 className="bold text-xl border-b mb-8 p-4">
          Configurable Product Values
        </h3>
        <div className="w-full md:w-1/2 lg:w-2/5 p-4">
          <InputBox
            type="text"
            placeholder="Salesforce ID"
            label="Salesforce ID"
            name={formik.getFieldProps("salesforce_id").name}
            value={formik.getFieldProps("salesforce_id").value}
            onChange={formik.getFieldProps("salesforce_id").onChange}
            onBlur={formik.getFieldProps("salesforce_id").onBlur}
            touched={formik.touched.salesforce_id}
            error={formik.errors.salesforce_id}
          />
          <InputBox
            type="text"
            placeholder="Account name"
            label="Account Name"
            name={formik.getFieldProps("account_name").name}
            value={formik.getFieldProps("account_name").value}
            onChange={formik.getFieldProps("account_name").onChange}
            onBlur={formik.getFieldProps("account_name").onBlur}
            touched={formik.touched.account_name}
            error={formik.errors.account_name}
          />
          <InputBox
            type="text"
            placeholder="Full name"
            label="Organization Name"
            name={formik.getFieldProps("full_name").name}
            value={formik.getFieldProps("full_name").value}
            onChange={formik.getFieldProps("full_name").onChange}
            onBlur={formik.getFieldProps("full_name").onBlur}
            touched={formik.touched.full_name}
            error={formik.errors.full_name}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Acronym"
            name={formik.getFieldProps("acronym_name").name}
            value={formik.getFieldProps("acronym_name").value}
            onChange={formik.getFieldProps("acronym_name").onChange}
            onBlur={formik.getFieldProps("acronym_name").onBlur}
            touched={formik.touched.acronym_name}
            error={formik.errors.acronym_name}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Colloquial Name"
            name={formik.getFieldProps("colloquial_name").name}
            value={formik.getFieldProps("colloquial_name").value}
            onChange={formik.getFieldProps("colloquial_name").onChange}
            onBlur={formik.getFieldProps("colloquial_name").onBlur}
            touched={formik.touched.colloquial_name}
            error={formik.errors.colloquial_name}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Colloquial Phrase"
            name={formik.getFieldProps("colloquial_phrase").name}
            value={formik.getFieldProps("colloquial_phrase").value}
            onChange={formik.getFieldProps("colloquial_phrase").onChange}
            onBlur={formik.getFieldProps("colloquial_phrase").onBlur}
            touched={formik.touched.colloquial_phrase}
            error={formik.errors.colloquial_phrase}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Colloquial Letters"
            name={formik.getFieldProps("colloquial_letters").name}
            value={formik.getFieldProps("colloquial_letters").value}
            onChange={formik.getFieldProps("colloquial_letters").onChange}
            onBlur={formik.getFieldProps("colloquial_letters").onBlur}
            touched={formik.touched.colloquial_letters}
            error={formik.errors.colloquial_letters}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Default Name"
            name={formik.getFieldProps("default_name").name}
            value={formik.getFieldProps("default_name").value}
            onChange={formik.getFieldProps("default_name").onChange}
            onBlur={formik.getFieldProps("default_name").onBlur}
            touched={formik.touched.default_name}
            error={formik.errors.default_name}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Founding Year"
            name={formik.getFieldProps("founding_year").name}
            value={formik.getFieldProps("founding_year").value}
            onChange={formik.getFieldProps("founding_year").onChange}
            onBlur={formik.getFieldProps("founding_year").onBlur}
            touched={formik.touched.founding_year}
            error={formik.errors.founding_year}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Motto"
            name={formik.getFieldProps("motto").name}
            value={formik.getFieldProps("motto").value}
            onChange={formik.getFieldProps("motto").onChange}
            onBlur={formik.getFieldProps("motto").onBlur}
            touched={formik.touched.motto}
            error={formik.errors.motto}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Motto Short"
            name={formik.getFieldProps("motto_short").name}
            value={formik.getFieldProps("motto_short").value}
            onChange={formik.getFieldProps("motto_short").onChange}
            onBlur={formik.getFieldProps("motto_short").onBlur}
            touched={formik.touched.motto_short}
            error={formik.errors.motto_short}
          />
          <InputBox
            type="text"
            placeholder=""
            label="Motto Long"
            name={formik.getFieldProps("motto_long").name}
            value={formik.getFieldProps("motto_long").value}
            onChange={formik.getFieldProps("motto_long").onChange}
            onBlur={formik.getFieldProps("motto_long").onBlur}
            touched={formik.touched.motto_long}
            error={formik.errors.motto_long}
          />
          <InputBox
            type="text"
            placeholder=""
            label="City"
            name={formik.getFieldProps("city").name}
            value={formik.getFieldProps("city").value}
            onChange={formik.getFieldProps("city").onChange}
            onBlur={formik.getFieldProps("city").onBlur}
            touched={formik.touched.city}
            error={formik.errors.city}
          />
          <InputBox
            type="text"
            placeholder=""
            label="State"
            name={formik.getFieldProps("state").name}
            value={formik.getFieldProps("state").value}
            onChange={formik.getFieldProps("state").onChange}
            onBlur={formik.getFieldProps("state").onBlur}
            touched={formik.touched.state}
            error={formik.errors.state}
          />
          <div className="w-full mb-4">
            <label
              htmlFor="menu_name"
              className="block text-sm font-medium text-gray-700"
            >
              Select a Category
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <select
                id={formik.getFieldProps("category").name}
                name={formik.getFieldProps("category").name}
                autoComplete={formik.getFieldProps("category").name}
                value={formik.getFieldProps("category").value}
                onChange={formik.getFieldProps("category").onChange}
                className="w-full border-r border-gray-300 py-2 focus:ring-indigo-500 focus:border-indigo-500 h-full pl-3 pr-7 bg-gray-50 text-gray-500 sm:text-sm rounded-md"
              >
                <option value="none" disabled hidden>
                  Select a Category
                </option>
                {[
                  "None",
                  "College",
                  "Panhellenic",
                  "IFC",
                  "Multicultural Greeks",
                  "NPHC",
                  "Pre-Professional",
                  "Official Sports",
                  "Student Organization",
                  "Club Sports",
                  "Program",
                  "Department",
                  "Dance Marathon",
                  "Alumni Associations",
                ].map(function (item, index) {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="w-full mb-4">
            <label
              htmlFor="category"
              className="block text-sm font-medium text-gray-700"
            >
              Select a Campus Category
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <select
                id={formik.getFieldProps("menu_name").name}
                name={formik.getFieldProps("menu_name").name}
                autoComplete={formik.getFieldProps("menu_name").name}
                value={formik.getFieldProps("menu_name").value}
                onChange={formik.getFieldProps("menu_name").onChange}
                className="w-full border-r border-gray-300 py-2 focus:ring-indigo-500 focus:border-indigo-500 h-full pl-3 pr-7 bg-gray-50 text-gray-500 sm:text-sm rounded-md"
              >
                <option value="none" disabled hidden>
                  Select a Campus Category
                </option>
                {[
                  "None",
                  "College",
                  "Panhellenic",
                  "IFC",
                  "Multicultural Greeks",
                  "NPHC",
                  "Pre-Professional",
                  "Official Sports",
                  "Student Organization",
                  "Club Sports",
                  "Program",
                  "Department",
                  "Dance Marathon",
                  "Alumni Associations",
                ].map(function (item, index) {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="w-full mb-4">
            <label
              htmlFor=""
              className="block text-sm font-medium text-gray-700"
            >
              Select a Organization Affinity ID
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <select
                id={formik.getFieldProps("affinity_organization_id").name}
                name={formik.getFieldProps("affinity_organization_id").name}
                autoComplete={
                  formik.getFieldProps("affinity_organization_id").name
                }
                value={formik.getFieldProps("affinity_organization_id").value}
                onChange={
                  formik.getFieldProps("affinity_organization_id").onChange
                }
                className="w-full border-r border-gray-300 py-2 focus:ring-indigo-500 focus:border-indigo-500 h-full pl-3 pr-7 bg-gray-50 text-gray-500 sm:text-sm rounded-md"
              >
                <option value="none" disabled hidden>
                  Select a Organization ID
                </option>
                {affinity_clients.data.map(function (item, index) {
                  return (
                    <option key={index} value={item.id}>
                      {item.name
                        ? item.name
                        : item.short_name
                        ? item.short_name
                        : item.id}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className="mt-12">
            <label
              htmlFor="text"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Custom Product Tags
            </label>
            <ReactTags
              autofocus={false}
              inputValue={tagInputValue}
              handleInputChange={setTagInputValue}
              tags={formik.getFieldProps("tags").value}
              allowDeleteFromEmptyInput={false}
              delimiters={delimiters}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              classNames={{
                tag: '" mx-2 inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-gray-100 text-gray-800"',
                tagInputField:
                  "mt-2 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md",

                tagInput:
                  "shadow-sm block w-full sm:text-sm border-gray-300 rounded-md",
              }}
            />
            <button
              type="submit"
              onClick={() => {
                handleAddition({ id: tagInputValue, text: tagInputValue });
                setTagInputValue("");
              }}
              disabled={tagInputValue.length === 0}
              className="mt-2 bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
            >
              Add Tag
            </button>
          </div>
        </div>
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button
            type="submit"
            onClick={formik.submitForm}
            className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
          >
            Save
          </button>
        </div>
      </div>

      <div className="my-8  w-full border border-b  rounded ">
        <div className="flex items-center w-full my-8 p-4">
          <Toggle
            onoff={checkNational(organization.national)}
            onChange={handleIsNationalChange}
          />
          <p className="ml-2">National Greek Organization</p>
        </div>
      </div>

      <div className="my-8  w-full border border-b  rounded ">
        <h3 className="bold text-xl border-b mb-8  p-4">Parents</h3>

        <div className="px-4 pb-4 w-full md:w-1/2">
          <h3 className="block text-sm font-medium text-gray-700 mb-1">
            Add parent organizations
          </h3>
          {/* @ts-ignore */}
          <ParentSearchBox
            onSelect={async ({ salesforce_id }: { salesforce_id: string }) => {
              await api.put(`organizations/${organization.salesforce_id}`, {
                parents: union(organization.parents, [salesforce_id]),
              });

              fetchOrg();
            }}
          />
        </div>
        {parents && parents.length > 0 && (
          <ul className="divide-y divide-gray-200  p-4">
            {parents &&
              parents.length > 0 &&
              parents.map(function (parent, index) {
                return (
                  <div
                    className="flex justify-between items-center"
                    key={index}
                  >
                    <div className="flex flex-col my-4 pt-4">
                      <div className="flex flex-col">
                        <span className="text-sm font-medium text-gray-900">
                          {parent?.category}
                        </span>
                        <span className="text-sm text-gray-500">
                          {parent?.salesforce_id}
                        </span>
                        <span className="text-sm text-gray-500">
                          {parent?.full_name}
                        </span>
                      </div>
                    </div>
                    <p
                      onClick={async () => {
                        await api.put(
                          `organizations/${organization.salesforce_id}`,
                          {
                            parents: remove(
                              organization.parents,
                              function (current_salesforce_id) {
                                return (
                                  current_salesforce_id ===
                                  parent?.salesforce_id
                                );
                              }
                            ),
                          }
                        );

                        fetchOrg();
                      }}
                      className="text-sm text-gray-500 cursor-pointer"
                    >
                      Delete
                    </p>
                  </div>
                );
              })}
          </ul>
        )}
      </div>
      <StoreCollectionsTable salesforce_id={organization.salesforce_id} />
      <MembersTable
        members={members}
        onCreateNew={() => {
          setCreateMemberModalVisible(true);
        }}
      />
      <DesignProducTemplate salesforce_id={organization.salesforce_id} />
      <CreateMemberModal
        visible={createMemberModalVisible}
        setVisible={setCreateMemberModalVisible}
        org_salesforce_id={
          organization?.salesforce_id ? organization?.salesforce_id : ""
        }
        activity={organization?.full_name ? organization?.full_name : ""}
        colleges={organization.parents}
      />
    </div>
  );
};
